module.exports = __webpack_public_path__ + "public/images/workouts-fitness.0ede0d59bb7baa3a617e7bdc965ad61b.jpg";